import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";
import { LabelsDto } from "api/dtos/LabelsDto";

const getLabels = async () => {
  try {
    const res = await axiosInstance.get(`${URLS.labels}/`);
    const data = LabelsDto.fromApiArray(res.data);
    return data;
  } catch (error) {
    throw error;
  }
};

const createLabel = async ({ labelData, userIds, fieldIds }) => {
  try {
    const payload = LabelsDto.toApi({ labelData, userIds, fieldIds });
    const res = await axiosInstance.post(`${URLS.labels}/`, payload);
    const data = LabelsDto.fromApi(res.data);
    return data;
  } catch (error) {
    throw error;
  }
};

const updateLabel = async (id, labelData) => {
  try {
    const payload = LabelsDto.toApi({ labelData });
    const res = await axiosInstance.patch(`${URLS.labels}/${id}/`, payload);
    const data = LabelsDto.fromApi(res.data);
    return data;
  } catch (error) {
    throw error;
  }
};

const deleteLabel = async (id) => {
  try {
    await axiosInstance.delete(`${URLS.labels}/${id}/`);
  } catch (error) {
    throw error;
  }
};

const addLabelToResource = async (id, type, resourceId) => {
  try {
    const payload = LabelsDto.toApiResource(type, resourceId);
    const res = await axiosInstance.post(`${URLS.labels}/${id}/add/`, payload);
    return res.data;
  } catch (error) {
    throw error;
  }
};

const removeLabelFromResource = async (id, type, resourceId) => {
  try {
    const payload = LabelsDto.toApiResource(type, resourceId);
    const res = await axiosInstance.post(
      `${URLS.labels}/${id}/remove/`,
      payload
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const labelsApi = {
  availableLabels: getLabels,
  createLabel,
  updateLabel,
  deleteLabel,
  addLabelToResource,
  removeLabelFromResource,
};
